import { liftingSystemsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("lifting-system"),
  endpoint: "lifting-systems",
  operations: liftingSystemsOps,
  roleView: [ROLE.TRUCK_VIEW, ROLE.TRUCK_ADMIN],
  roleAdmin: [ROLE.TRUCK_ADMIN],

  singularName: (t) => t("Lifting System"),
  name: (t) => t("Lifting Systems"),
  syncCustomerFilter: true,
});

export default conf;
